import { useTheme } from '@mui/styles';

export const usePositionCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
    text: {
      paddingTop: theme.spacing(1.25),
    },
  };
};
